import { oneLine } from 'common-tags';

import { Container, Text } from '@/atoms';
import { CardZone, Grid } from '@/molecules';

import { sectionBgProps, textStyleClass } from '@/utils';
import { getRealUrl } from '@/utils/utils';

/**
 * ComponentRevisadasZonsasDistributiva
 */
export const ComponentRevisadasZonsasDistributiva = ({
  Titulo,
  descripcion,
  TituloEstilo,
  DescripcionEstilo,
  zonas,
  FondoSeccion,
}: any) => {
  const tituloCls = textStyleClass(TituloEstilo);
  const descripcionCls = textStyleClass(DescripcionEstilo);
  return (
    <Container wrapper {...sectionBgProps(FondoSeccion)}>
      <div className="mb-6 flex flex-col items-center justify-center gap-2">
        <Text
          className={oneLine`text-headline ${tituloCls ?? 'text-headline-h3'}`}
        >
          {Titulo}
        </Text>
        <Text className={oneLine`text-body ${descripcionCls ?? 'text-body-l'}`}>
          {descripcion}
        </Text>
      </div>

      <Grid xxs={1} sm={2} lg={3} className="gap-6">
        {zonas.map((itm: any, index: number) => (
          <Grid.Item key={`zonas-${index}`}>
            <CardZone
              title={`En ${itm.Nombre}`}
              image={{
                src: getRealUrl(itm.Imagen.url),
                alt: itm.Imagen.alternativeText,
              }}
              href={itm.slug}
              className="text-neutrals-900"
            />
          </Grid.Item>
        ))}
      </Grid>
    </Container>
  );
};

ComponentRevisadasZonsasDistributiva.displayName =
  'ComponentRevisadasZonsasDistributiva';
